import React, { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { Container, Row, Col, Card, Form, Button, Alert, Spinner } from 'react-bootstrap';
import Header from '../Header';

const UserAddServices = () => {
  const [successMessage, setSuccessMessage] = useState('');
  const [error, setError] = useState(null);
  const [services, setServices] = useState([]);
  const [plans, setPlans] = useState([]);
  const [loadingPlans, setLoadingPlans] = useState(false);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const { uid } = useParams();

  const [user, setUser] = useState({
    service: '',
    plan: '',
    plan_id: '',
    customPlan: '',
    totalAmount: '',
    remarks: '',
    dor: '',
  });

  useEffect(() => {
    fetch('https://apiaksharaconnect.aksharafinalytics.in/getservices')
      .then(response => response.json())
      .then(data => setServices(data || []))
      .catch(() => setError('Error fetching services.'));
  }, []);

  const handleServiceChange = async (e) => {
    const selectedService = e.target.value;
    setUser(prev => ({ ...prev, service: selectedService, plan: '', customPlan: '', plan_id: '' }));
    if (selectedService) {
      setLoadingPlans(true);
      try {
        const response = await fetch(`https://apiaksharaconnect.aksharafinalytics.in/getplans/${selectedService}`);
        const data = await response.json();
        setPlans(data || []);
      } catch {
        setError('Error fetching plans for the selected service.');
      } finally {
        setLoadingPlans(false);
      }
    } else {
      setPlans([]);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;

    if (name === 'plan') {
      const selectedPlan = plans.find(plan => plan.id.toString() === value);
      const isOthers = selectedPlan?.name.toLowerCase() === 'others';
      setUser(prev => ({
        ...prev,
        plan: selectedPlan?.name || '',
        plan_id: selectedPlan?.id || '',
        customPlan: isOthers ? '' : prev.customPlan,
      }));
    } else {
      setUser(prev => ({ ...prev, [name]: value }));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
  
    const userData = {
      ...user,
      plan: user.plan_id === '' || user.plan.toLowerCase() === 'others' ? user.customPlan : user.plan,
      user_id: uid,
    };
  
    console.log('Submitting the following data:', userData);
  
    try {
      const response = await fetch('https://apiaksharaconnect.aksharafinalytics.in/addservice', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(userData),
      });
  
      const data = await response.json();
  
      // Log error if response is not ok
      if (!response.ok) {
        console.error('API Error:', data);  // 👈 Logs full error response from server
        throw new Error(data.message || response.statusText);
      }
  
      if (data.message) {
        if(data.message == 'Service already registered by user.'){
            setError(data.message);
        }else {
            setSuccessMessage(data.message);
        
            setUser({
            service: '',
            plan: '',
            plan_id: '',
            customPlan: '',
            totalAmount: '',
            remarks: '',
            dor: '',
            });
        }
      } else if (data.error) {
        console.error('API Response Error:', data.error);  // 👈 Logs specific API error
        setError(data.error);
      }
    } catch (err) {
      console.error('Submission error:', err.message);  // 👈 Catch block logs general error
      setError('There was an error submitting the user. Please try again.');
    } finally {
      setLoading(false);
      setTimeout(() => {
        setSuccessMessage('');
        setError(null);
      }, 5000);
    }
  };
  

  return (
    <>
      <Header />
      <Container className="mt-5">
        {successMessage && <Alert variant="success">{successMessage}</Alert>}
        {error && <Alert variant="danger">{error}</Alert>}

        <Card className="shadow">
          <Card.Header>
            <h2>Add Services</h2>
          </Card.Header>

          <Card.Body>
            {loading ? (
              <div className="text-center my-5">
                <Spinner animation="border" role="status" />
                <div className="mt-3">Submitting ...</div>
              </div>
            ) : (
              <Form onSubmit={handleSubmit}>
                <Row>
                  <Col md={6} className="mb-3">
                    <Form.Label>Service</Form.Label>
                    <Form.Control as="select" name="service" value={user.service} onChange={handleServiceChange} required>
                      <option value="">-- Select Service --</option>
                      {services.length > 0 ? (
                        services.map(service => (
                          <option key={service.id} value={service.id}>
                            {service.name}
                          </option>
                        ))
                      ) : (
                        <option disabled>No services available</option>
                      )}
                    </Form.Control>
                  </Col>

                  <Col md={6} className="mb-3">
                    <Form.Label>Plan</Form.Label>
                    <Form.Control as="select" name="plan" value={user.plan_id || ''} onChange={handleChange} required>
                      <option value="">-- Select Plan --</option>
                      {loadingPlans ? (
                        <option disabled>Loading...</option>
                      ) : plans.length > 0 ? (
                        plans.map(plan => (
                          <option key={plan.id} value={plan.id}>
                            {plan.name} - {plan.price}/-
                          </option>
                        ))
                      ) : (
                        <option disabled>No plans available</option>
                      )}
                    </Form.Control>
                  </Col>

                  {(user.plan_id === '42' || user.plan_id === '43') && (
                    <Col md={6} className="mb-3">
                      <Form.Label>Others </Form.Label>
                      <Form.Control type="text" name="customPlan"  value={user.customPlan} onChange={handleChange} required/>
                    </Col>
                  )}
                </Row>

                <Row>
                  <Col md={6} className="mb-3">
                    <Form.Label>Total Amount</Form.Label>
                    <Form.Control type="text" name="totalAmount" value={user.totalAmount} onChange={handleChange} required />
                  </Col>
                  <Col md={6} className="mb-3">
                    <Form.Label>Remarks</Form.Label>
                    <Form.Control type="text" name="remarks" value={user.remarks} onChange={handleChange} required />
                  </Col>
                  <Col md={6} className="mb-3">
                    <Form.Label>Date</Form.Label>
                    <Form.Control type="date" name="dor" value={user.dor} onChange={handleChange} required />
                  </Col>
                </Row>

                <div className="text-center">
                  <Button type="submit" variant="primary">
                    Submit
                  </Button>
                </div>
              </Form>
            )}
          </Card.Body>
        </Card>
      </Container>
    </>
  );
};

export default UserAddServices;
